import React from "react"
import {
    componentStyles,
    HorizontalStack,
    Text,
    useColors,
    useTheme,
} from "@mallardbay/lib-react-components"

import FeatureStatusLabel, {
    FeatureStatus,
} from "~components/shared/feature-status-label"
import SparkleIcon from "~components/shared/icons/sparkle-icon"
import COPY from "~config/copy-constants"

const ICON_SIZE = 18

export default function AssistantTitle({
    title = COPY.OUTFITTER_ASSISTANT_NAME,
    shouldShowIcon = false,
    size = "md",
}: Props) {
    const styles = useStyles(size)

    return (
        <HorizontalStack style={styles.root}>
            {shouldShowIcon && <SparkleIcon size={ICON_SIZE} isBrandColor />}
            <Text style={styles.title}>{title}</Text>
            <FeatureStatusLabel featureStatus={FeatureStatus.Beta} isRounded />
        </HorizontalStack>
    )
}

function useStyles(size: AssistantTitleSize) {
    const colors = useColors()
    const theme = useTheme()

    return componentStyles({
        root: {
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
        },
        title: {
            color: colors.text,
            fontSize: size === "lg" ? theme.fontSizes.lg : theme.fontSizes.md,
            fontWeight: theme.fontWeights.semibold,
        },
    })
}

type AssistantTitleSize = "md" | "lg"

interface Props {
    readonly title?: string
    readonly shouldShowIcon?: boolean
    readonly size?: AssistantTitleSize
}
